import { resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "forward-geocoding-input-row" }
const _hoisted_2 = ["onClick", "onKeyup"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "forward-geocoding-container",
    ref: "container",
    style: _normalizeStyle(_ctx.cssStyles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_v_text_field, {
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        class: _normalizeClass(['forward-geocoding-input', _ctx.small ? 'forward-geocoding-input-small' : '']),
        label: _ctx.locationJustUpdated ? 'Location Updated' : 'Enter a location',
        "bg-color": "transparent",
        density: "compact",
        "hide-details": "",
        variant: "solo",
        color: _ctx.accentColor,
        onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        onKeyup: [
          _cache[2] || (_cache[2] = _withKeys(() => _ctx.performForwardGeocodingSearch(), ["enter"])),
          _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchResults = null), ["esc"]))
        ],
        "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchResults = null)),
        "error-messages": _ctx.searchErrorMessage
      }, null, 8, ["modelValue", "class", "label", "color", "error-messages"]), [
        [_vShow, _ctx.searchOpen]
      ]),
      _createElementVNode("div", {
        class: "icon-wrapper geocoding-search-icon",
        ref: "searchIcon",
        tabindex: "0",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.activateSearchIcon && _ctx.activateSearchIcon(...args))),
        onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.activateSearchIcon && _ctx.activateSearchIcon(...args)), ["enter"]))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "magnifying-glass",
          size: _ctx.searchOpen ? 'xl' : _ctx.buttonSize,
          color: !_ctx.searchOpen || (_ctx.searchText && _ctx.searchText.length > 2) ? _ctx.accentColor : 'gray'
        }, null, 8, ["size", "color"])
      ], 544),
      _renderSlot(_ctx.$slots, "append-icon", { class: "geocode-icon" })
    ]),
    (_openBlock(), _createBlock(_Teleport, {
      to: "body",
      disabled: !_ctx.escapeContainer
    }, [
      (_ctx.searchResults !== null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["forward-geocoding-results", [_ctx.small ? 'results-small' : '', _ctx.openUpward ? 'results-up' : '']]),
            style: _normalizeStyle(_ctx.escapeContainer ? { ..._ctx.cssStyles, ..._ctx.escapedResultsStyle } : null)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.searchResults !== null ?  _ctx.searchResults.features : []), (feature, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "forward-geocoding-result",
                key: index,
                tabindex: "0",
                onClick: () => _ctx.setLocationFromSearchFeature(feature),
                onKeyup: _withKeys(() => _ctx.setLocationFromSearchFeature(feature), ["enter"])
              }, _toDisplayString(feature.place_name), 41, _hoisted_2))
            }), 128))
          ], 6))
        : _createCommentVNode("", true)
    ], 8, ["disabled"]))
  ], 4))
}